export function MutedText({ children }) {
  return <span className="text-gray-400">{children}</span>;
}
